import firebase from 'firebase/app'
import 'firebase/database'
import { reactive, toRef, toRefs } from '@vue/composition-api'

const state = reactive({
  cancel: null,
  participantKey: null,
  participantStatusDatabaseRef: null,
  event: { name: '', timestamp: Date.now() },
})

export default () => {
  const database = firebase.database()

  if (!state.participantKey) {
    state.participantKey = database.ref('participants').push().key
    state.participantStatusDatabaseRef = database.ref(`participants/${state.participantKey}`)
    database.ref(`participants/${state.participantKey}/event`).on('value', function (snapshot) {
      // actions comes in the format 'name@timestamp'
      const [name, timestamp] = (snapshot.val() || '').split('@')
      state.event = {
        name,
        timestamp
      }
    })
  }

  function connect(defaultValue) {
    if (!state.cancel) {
      state.cancel = firebase.database().ref('.info/connected').on('value', function (snapshot) {
        if (!snapshot || snapshot.val() == false) {
          return
        }

        state.participantStatusDatabaseRef.onDisconnect().remove().then(function () {
          state.participantStatusDatabaseRef.set({
            ...defaultValue,
            dateCreated: firebase.database.ServerValue.TIMESTAMP
          })
        })
      })
    }
  }

  async function disconnect() {
    if (state.cancel) {
      await state.participantStatusDatabaseRef.remove()

      state.cancel()
      state.cancel = null
    }
  }

  return {
    ...toRefs(state),
    connect,
    disconnect,
  }
}

export const participantStatusDatabaseRef = toRef(state, 'participantStatusDatabaseRef')